import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Card, Button, List, Label } from 'semantic-ui-react'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionButton: {
    display: 'flex',
    flexDirection: 'row',
  },
}

const Row = ({ field, value, color }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>{field}</div>
        <div style={{ display: 'flex' }}>
          <Label size="medium" color={color}>
            {value}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

const FreeCheckoutCard = ({ freeCheckout, onEdit, onDelete }) => {
  const promotionName = freeCheckout.title || 'N/A'
  const merchantCount = freeCheckout.all_merchants ? 'All' : _.size(freeCheckout.merchants)
  const merchantColor = freeCheckout.all_merchants ? 'green' : undefined

  const startedDate = moment(freeCheckout.started_at).format('DD-MMM-YYYY')
  const endedDate = moment(freeCheckout.ended_at).format('DD-MMM-YYYY')

  const restrictedAge = freeCheckout.restricted_age ? 'Yes' : 'No'
  const restrictedAgeColor = freeCheckout.restricted_age ? 'green' : 'red'

  return (
    <Card style={{ marginLeft: 30 }}>
      <Card.Content>
        <Card.Header>{promotionName}</Card.Header>
        <Card.Description>
          <List divided verticalAlign="middle" style={{ marginTop: 10 }}>
            <Row field="Merchants" value={merchantCount} color={merchantColor} />
            <Row field="Restricted Age" value={restrictedAge} color={restrictedAgeColor} />
            <Row field="Started at" value={startedDate} />
            <Row field="Ended at" value={endedDate} />
          </List>
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div style={styles.actionButton}>
          <Button
            size="tiny"
            color="black"
            content="Edit"
            onClick={onEdit}
            style={{ width: '100%' }}
          />
          <Button
            size="tiny"
            color="red"
            content="Delete"
            onClick={onDelete}
            style={{ width: '100%' }}
          />
        </div>
      </Card.Content>
    </Card>
  )
}

export default FreeCheckoutCard



// WEBPACK FOOTER //
// ./src/containers/promotions/components/FreeCheckouts/Card.js